module.exports = __webpack_public_path__ + "static/media/lexus-bumper_selected.9f6a0358.svg";